import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { IncodeContainer } from '../IncodeContainer';
import type { IncodeStepProps } from '../IncodeSDKHelpers';
import { INCODE_PROGRESS_STATUS, INCODE_PROGRESS_STEP, INCODE_ROUTES } from '../IncodeSDKHelpers';
import { usePostIncodeProgress } from '../progress/incodeProgress';

import LocalTexts from './Incode.texts.json';
import { IncodeCaptureDevHelper } from './IncodeCaptureDevHelper';

import styles from './IncodeCaptureV5c.module.scss';

const LocalT = new MDText(LocalTexts.CaptureV5c);

export const IncodeCaptureV5c = ({
  BASE_URL,
  incodeSDK,
  incodeSession,
}: IncodeStepProps) => {
  const incodeContainerRef = useRef<HTMLDivElement>(null);

  const history = useHistory();
  const { IncodeProgressLoading, postIncodeComplete } = usePostIncodeProgress();

  useEffect(() => {
    const incodeContainerRefCurrent = incodeContainerRef.current;
    const abortController = new AbortController();

    const defaultCompleteParams = {
      abortController,
      fallbackNextStep: INCODE_ROUTES.COMPLETE,
      incodeSession,
      step: INCODE_PROGRESS_STEP.V5,
    };

    const { close } = incodeSDK.renderCamera('document', incodeContainerRefCurrent, {
      documentType: 'processV5CLogbook',
      nativeCamera: true,
      onError: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.FAILED,
      }),
      onSuccess: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.SUCCESS,
      }),
      showTutorial: false,
      token: incodeSession,
      tutorialText: {
        step1: {
          subtitle: LocalT.translate('instructions.step1'),
          title: LocalT.translate('title'),
        },
        step2: {
          subtitle: LocalT.translate('instructions.step2'),
          title: LocalT.translate('title'),
        },
      },
    });

    return () => {
      abortController.abort();
      close();
    };
  }, [BASE_URL, history, incodeContainerRef, incodeSDK, incodeSession, postIncodeComplete]);

  return (
    <>
      <IncodeProgressLoading />
      <IncodeContainer ref={incodeContainerRef} noStyling className={styles.v5c} />
      <IncodeCaptureDevHelper to={INCODE_ROUTES.PROOF_OF_ADDRESS} />
    </>
  );
};
